import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	portalSettings: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.channels.portal-settings',
		defaultMessage: 'Portal',
		description: 'Settings navigation menu link for a service project',
	},
	emailRequests: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.channels.email-requests',
		defaultMessage: 'Email',
		description: 'Settings navigation menu link for a service project',
	},
	chat: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.channels.chat',
		defaultMessage: 'Chat',
		description: 'Settings navigation menu link for a service project',
	},
	widget: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.channels.widget',
		defaultMessage: 'Widget',
		description: 'Settings navigation menu link for a service project',
	},
	knowledgeBase: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.channels.knowledge-base',
		defaultMessage: 'Knowledge base',
		description: 'Settings navigation menu link for a service project',
	},
	itemBack: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.channels.item-back',
		defaultMessage: 'Back to project settings',
		description: '"Back" menu item.',
	},
	title: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.channels.title',
		defaultMessage: 'Project settings',
		description: 'Title for project settings navigation panel',
	},
	externalResources: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.channels.external-resources',
		defaultMessage: 'External resources',
		description: 'Nav item label for configuring external resources of a servicedesk project',
	},
	issueCollectors: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.channels.issue-collectors',
		defaultMessage: 'Issue collectors',
		description: 'Settings navigation menu link for a service project',
	},
});
